import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log('[form-debug] Controller connected')
    this.element.addEventListener('submit', this.logFormData.bind(this))
  }

  logFormData(event) {
    const formData = new FormData(this.element)
    console.log('[form-debug] Form submitting...')

    for (const [key, value] of formData.entries()) {
      console.log(`[form-debug] ${key}: ${value}`)
    }

    // Log all hidden fields specifically
    const hiddenFields = this.element.querySelectorAll('input[type="hidden"]')
    console.log('[form-debug] Hidden fields count:', hiddenFields.length)
    hiddenFields.forEach(field => {
      console.log(`[form-debug] Hidden: ${field.name} = ${field.value}`)
    })
  }
}
